<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent">
            <app-header class="dark-mode"
                        [backRoute]="['/home']"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="true" [@enter]>
            </app-header>
        </ion-header>
        <div class="bg bg-inner-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]></div>
        <div class="box" [@enter]>
            <div class="title">
                <div>{{'__REVIEW_REPORT_TITLE__' | translate }}</div>
            </div>
            <div class="subtitle primary-color">{{'__REVIEW_REPORT_SUBTITLE__' | translate }}</div>
        </div>
        <div class="shadow-container" *ngIf="reports === null">
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
        </div>

        <div class="shadow-container" *ngIf="reports !== null">
            <div class="shadow-container-description">
                <div>{{'__REVIEW_REPORT_LIST_TITLE1__' | translate}} <span style="font-weight: 600;">{{'__REVIEW_REPORT_LIST_TITLE2__' | translate}} <span style="color: #8dc63f;">[+]</span> {{'__REVIEW_REPORT_LIST_TITLE3__' | translate}}</span></div>
                <div class="shadow-container-description-buttons">
                    <app-inline-svg class='add-report-btn' *ngIf="!canAddOne2OneReport" [file]="'assets/icon/one2one.svg'"></app-inline-svg>
                    <app-inline-svg class='add-report-btn' *ngIf="canAddOne2OneReport" [routerLink]="['my/report/one2one']" [file]="'assets/icon/one2one-active.svg'"></app-inline-svg>
                    <app-inline-svg class='add-report-btn' *ngIf="!canAddReviewReport" [file]="'assets/icon/plus.svg'"></app-inline-svg>
                    <app-inline-svg class='add-report-btn' *ngIf="canAddReviewReport" [routerLink]="['my/report']" [file]="'assets/icon/plus-active.svg'"></app-inline-svg>
                </div>
            </div>
            <div class="table-header">
                <div style="text-align: left;">{{'__REVIEW_REPORT_LIST_HEADER_LINE_MANAGER__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_REVIEW_PERIOD__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_CREATED__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_LAST_SAVED__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_STATUS__' | translate}}</div>
            </div>
            <ng-container *ngFor="let report of reports">
                <div class="shadow-element" [routerLink]="report.type === 'review' ? ['my/report/' + report.id] : ['my/report/one2one/' + report.id]">
                    <div style="text-align: left;">{{report.manager?.full_name}}</div>
                    <div>{{report.type === 'review' ? report.period : '1 to 1 Meeting'}}</div>
                    <div>{{report.created_at.output.iso | amDateFormat : 'DD / MM / YY' }}</div>
                    <div>{{report.updated_at.output.iso | amDateFormat : 'DD / MM / YY'}}</div>
                    <div class="element-img status-img" (click)="changeStatus($event, report)">
                        <img src="assets/img/{{report.status ? 'check-active.svg' : 'check-disable.svg'}}" alt="">
                    </div>
                    <div class="element-img" style="justify-content: flex-end;" (click)="printReport($event, report)">
                        <img class='download-report-btn' src="assets/icon/report-download.svg"/>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!reports.length">
                <div class="shadow-element" style="text-align: left;"><div style="font-size: 1.5rem; color: grey;">{{'__REVIEW_REPORT_LIST_NO_ELEMENTS__' | translate}}</div></div>
            </ng-container>
        </div>
    </div>
</ion-content>
